/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LookupTypesEnum {
  PropertyTypes = 1,
  ApplianceTypes = 2,
  ApplianceManufacturers = 3,
  UserRoles = 4,
  RentPaymentTypes = 5,
  ServiceRequestStatuses = 6,
  TenantLeaseTypes = 7,
  ServiceTypes = 8,
  ServiceSubTypes = 9,
  TransactionFlowTypes = 10,
  PaymentTypes = 11,
  PayeeAccountTypes = 12,
  PayeeSubAccountTypes = 13,
  PaidByTypes = 14,
  PayFrequencyTypes = 15,
  PaymentDueAccountStatus = 16,
}
